import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _toLower from 'lodash/toLower';
import _get from 'lodash/get';
import _orderBy from 'lodash/orderBy';
import _isNil from 'lodash/isNil';
import _reduce from 'lodash/reduce';
import _size from 'lodash/size';
import { DEFAULT_SELECT_SORT_ORDER, SORT_OVERRIDE_INDEX } from 'tbase/constants/sortOrder';
import { EMPTY_ARRAY } from 'tbase/app.constants';
/**
* getSanitizedOptions used for sorting the options
* @param options: array of object
* if we want to give an explicit order to particular option then provide 'sortOverrideIndex' param in option
* @param sort: array of object, e.g: [{order: 'asc', field: 'label'}]
*/

export var getSanitizedOptions = function getSanitizedOptions(options) {
  var shouldSortOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var sort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_SELECT_SORT_ORDER;
  if (!shouldSortOptions) return options; // Maps given field values to lower case for sorting

  var sanitizedSortParams = _reduce(sort, function (_ref, sortParam) {
    var iteratees = _ref.iteratees,
        sortOrder = _ref.sortOrder;
    var field = sortParam.field,
        order = sortParam.order;
    return {
      iteratees: [].concat(_toConsumableArray(iteratees), [function (option) {
        return _toLower(_get(option, field));
      }]),
      sortOrder: [].concat(_toConsumableArray(sortOrder), [_toLower(order)])
    };
  }, {
    iteratees: EMPTY_ARRAY,
    sortOrder: EMPTY_ARRAY
  });

  var iteratees = sanitizedSortParams.iteratees,
      sortOrder = sanitizedSortParams.sortOrder;

  var groupedOptions = _reduce(options, function (_ref2, option) {
    var optionsToSort = _ref2.optionsToSort,
        optionsWithOverrideSortOrderByKeys = _ref2.optionsWithOverrideSortOrderByKeys;

    var sortOverrideIndex = _get(option, SORT_OVERRIDE_INDEX);

    if (_isNil(sortOverrideIndex)) return {
      optionsToSort: [].concat(_toConsumableArray(optionsToSort), [option]),
      optionsWithOverrideSortOrderByKeys: optionsWithOverrideSortOrderByKeys
    };
    return {
      optionsToSort: optionsToSort,
      optionsWithOverrideSortOrderByKeys: _objectSpread(_objectSpread({}, optionsWithOverrideSortOrderByKeys), {}, _defineProperty({}, sortOverrideIndex, option))
    };
  }, {
    optionsToSort: [],
    optionsWithOverrideSortOrderByKeys: {}
  });

  var optionsToSort = groupedOptions.optionsToSort,
      optionsWithOverrideSortOrderByKeys = groupedOptions.optionsWithOverrideSortOrderByKeys;

  var sortedOptions = _orderBy(optionsToSort, iteratees, sortOrder);

  var sanitizedOptions = _reduce(sortedOptions, function (optionsList, option) {
    while (!_isNil(optionsWithOverrideSortOrderByKeys[_size(optionsList)])) {
      optionsList.push(optionsWithOverrideSortOrderByKeys[_size(optionsList)]);
    }

    optionsList.push(option);
    return optionsList;
  }, []);

  return sanitizedOptions;
};